<template>
  <div class="b-vehicleCarSale">
    <div class="b-vehicleCarSale__img">
      <img :src="item.ImageUrl" alt="" />
    </div>
    <div class="b-vehicleCarSale__txts">
      <div class="b-vehicleCarSale__model">
        {{ item.Title }}
      </div>
      <div class="b-vehicleCarSale__year">
        <span>{{ dictionary.yearsLabel }}: {{ item.Year }}</span>
      </div>
      <div v-if="item.Locations" class="b-vehicleCarSale__locations">
        <i class="icon-pin"></i>
        {{ item.Locations }}
      </div>
    </div>
    <div class="b-vehicleCarSale__price">
      <div class="b-vehicleCarSale__price__dt">{{ dictionary.priceLabel }}</div>
      <div class="b-vehicleCarSale__price__dd">
        {{ item.Currency }}{{ item.PriceTxt }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
}
</script>
